import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { 
  EmergencyContactListResponse, 
  EmergencyContactResponse, 
  EmergencyContactRequest 
} from '../models/emergency-contact.model';

@Injectable({
  providedIn: 'root'
})
export class EmergencyContactService {
  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getEmergencyContacts(cognitoId: string): Observable<EmergencyContactListResponse> {
    return this.http.get<EmergencyContactListResponse>(`${this.baseUrl}/contact/${cognitoId}/list`);
  }

  createEmergencyContact(cognitoId: string, name: string, pref: string, phone: string, email: string): Observable<EmergencyContactResponse> {
    const body: EmergencyContactRequest = {
      identifier: {
        tenants: "adff7f6a-e97d-11eb-9a03-0242ac130003",
        app: "PortalAsistencia"
      },
      petition: {
        name,
        pref,
        phone,
        email
      }
    };
    return this.http.post<EmergencyContactResponse>(`${this.baseUrl}/contact/${cognitoId}/registred`, body);
  }

  updateEmergencyContact(cognitoId: string, id: number, name: string, pref: string, phone: string, email: string): Observable<EmergencyContactResponse> {
    const body: EmergencyContactRequest = {
      identifier: {
        tenants: "adff7f6a-e97d-11eb-9a03-0242ac130003",
        app: "PortalAsistencia"
      },
      petition: {
        id,
        name,
        pref,
        phone,
        email
      }
    };
    return this.http.put<EmergencyContactResponse>(`${this.baseUrl}/contact/${cognitoId}/update`, body);
  }
}
